/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Go_Home_ButtonInputs */

const en_offline_go_home_button = /** @type {(inputs: Offline_Go_Home_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to Home`)
};

const fr_offline_go_home_button = /** @type {(inputs: Offline_Go_Home_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retour à l'Accueil`)
};

const de_offline_go_home_button = /** @type {(inputs: Offline_Go_Home_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zur Startseite`)
};

const it_offline_go_home_button = /** @type {(inputs: Offline_Go_Home_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vai alla Home`)
};

const ru_offline_go_home_button = /** @type {(inputs: Offline_Go_Home_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перейти на главную страницу`)
};

const es_offline_go_home_button = /** @type {(inputs: Offline_Go_Home_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir a Inicio`)
};

const zh_cn2_offline_go_home_button = /** @type {(inputs: Offline_Go_Home_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`返回首页`)
};

const ja_offline_go_home_button = /** @type {(inputs: Offline_Go_Home_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ホームへ戻る`)
};

const hi_offline_go_home_button = /** @type {(inputs: Offline_Go_Home_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`होम पेज पर जाएं`)
};

const pt_pt2_offline_go_home_button = /** @type {(inputs: Offline_Go_Home_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir para a página inicial`)
};

/**
* | output |
* | --- |
* | "Go to Home" |
*
* @param {Offline_Go_Home_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_go_home_button = /** @type {((inputs?: Offline_Go_Home_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Go_Home_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_offline_go_home_button(inputs)
	if (locale === "de") return de_offline_go_home_button(inputs)
	if (locale === "it") return it_offline_go_home_button(inputs)
	if (locale === "ru") return ru_offline_go_home_button(inputs)
	if (locale === "es") return es_offline_go_home_button(inputs)
	if (locale === "zh-CN") return zh_cn2_offline_go_home_button(inputs)
	if (locale === "ja") return ja_offline_go_home_button(inputs)
	if (locale === "hi") return hi_offline_go_home_button(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_go_home_button(inputs)
	return en_offline_go_home_button(inputs)
});